import { X } from 'lucide-react';
import type { NavBannerContent } from './navBannerRegistry';

interface NavBannerProps {
  banner: NavBannerContent;
  onDismiss: () => void;
}

export default function NavBanner({ banner, onDismiss }: NavBannerProps) {
  return (
    <div className="overflow-hidden border-b border-[#D9B33C] bg-[#F6D15B] text-black">
      <div className="container mx-auto px-4">
        <div className="flex items-center gap-2 py-1.5 sm:justify-between sm:gap-3 sm:py-2">
          <div className="min-w-0 flex-1 pr-1 text-[13px] font-semibold leading-5 sm:pr-4 sm:text-sm">
            <span className="block truncate sm:hidden">{banner.mobileMessage}</span>
            <span className="hidden sm:inline">{banner.message}</span>
          </div>
          <div className="flex shrink-0 items-center gap-1.5 sm:gap-2">
            <a
              href={banner.href}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex min-h-11 items-center justify-center rounded-full bg-black px-3.5 py-2 text-sm font-semibold text-white transition-colors duration-200 hover:bg-[#1F1F1F] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-black sm:min-h-9 sm:px-4"
            >
              <span className="sm:hidden">{banner.mobileCtaLabel}</span>
              <span className="hidden sm:inline">{banner.ctaLabel}</span>
            </a>
            <button
              type="button"
              onClick={onDismiss}
              aria-label={banner.dismissLabel}
              className="inline-flex h-11 w-11 items-center justify-center rounded-full text-black transition-colors duration-200 hover:bg-black/10 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-black sm:h-9 sm:w-9"
            >
              <X className="h-5 w-5" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
